import { createContext } from 'react';
import EnvVariableContainer from '../EnvVariableContainer';

const defaultContainer = new EnvVariableContainer();

export default createContext(defaultContainer);
